export class UtilSequenceProcess {
    static processList(list, asyncJob) {
        let sequence = Promise.resolve();
        list.forEach(function (item) {
            sequence = sequence.then(function () {
                return asyncJob(item);
            });
        });
        return sequence;
    }
    static processRange(startIndex, endIndex, asyncJob) {
        let sequence = Promise.resolve();
        for (let i = startIndex; i <= endIndex; i++) {
            sequence = sequence.then(function () {
                return asyncJob(i);
            });
        }
        return sequence;
    }
}
